import { render, staticRenderFns } from "./ForbiddenGoodsHead.vue?vue&type=template&id=fbf5e526&scoped=true"
import script from "./ForbiddenGoodsHead.vue?vue&type=script&lang=js"
export * from "./ForbiddenGoodsHead.vue?vue&type=script&lang=js"
import style0 from "./ForbiddenGoodsHead.vue?vue&type=style&index=0&id=fbf5e526&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf5e526",
  null
  
)

export default component.exports